import { colorVariants, type ColorVariant } from "./colorVariants";

export function resolveColorVariant(token?: string | null) {
  const key = (token ?? "white") as ColorVariant;
  return colorVariants[key] ?? colorVariants.white;
}
